var map = {
	"./add.svg": 223,
	"./arrowDown.svg": 113,
	"./arrowUp.svg": 114,
	"./br.svg": 224,
	"./camera.svg": 225,
	"./copy.svg": 226,
	"./delete.svg": 227,
	"./done.svg": 228,
	"./en.svg": 229,
	"./es.svg": 230,
	"./faceFrame.svg": 231,
	"./face_overlay.svg": 232,
	"./restart.svg": 233,
	"./settings-white.svg": 234,
	"./success.svg": 235,
	"./take_photo.svg": 236,
	"./translate.svg": 115,
	"./us.svg": 237,
	"./values.svg": 238,
	"./white-camera.svg": 239,
	"./white-check.svg": 240,
	"./white-restart.svg": 241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;